// extracted by mini-css-extract-plugin
module.exports = {"panel":"dropdown_panel__u6gtf","open":"dropdown_open__9ZSxz","body":"dropdown_body__gLbgX","button":"dropdown_button__sKOkg","header":"dropdown_header__GouwQ"};